import classNames from 'classnames';
import React, { memo, useEffect, useState } from 'react';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import Col from '../Utils/Col/Col';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';

const TestingGrid = () => {
  const screenSizeClasses = classNames(
    `fixed top-0 left-0 pointer-events-none z-[100] py-2 px-4 flex items-center text-xs font-semibold text-text/body-accent bg-surface/background rounded-br-[10px]`
  );

  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isControlKeyHeldDown, setIsControlKeyHeldDown] =
    useState<boolean>(false);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDownAction);
    window.addEventListener('keyup', handleKeyUpAction);
    return () => {
      window.removeEventListener('keydown', handleKeyDownAction);
      window.removeEventListener('keyup', handleKeyUpAction);
    };
  });

  const handleKeyDownAction = ({ key }: KeyboardEvent): void => {
    if (isControlKey(key)) {
      setIsControlKeyHeldDown(true);
    } else {
      if (isGKey(key) && isControlKeyHeldDown) {
        setIsVisible(!isVisible);
      }
    }
  };

  const handleKeyUpAction = ({ key }: KeyboardEvent) => {
    if (isControlKey(key)) {
      setIsControlKeyHeldDown(false);
    }
  };

  const isControlKey = (key: string) => {
    return isKey(key, 'Control');
  };

  const isGKey = (key: string) => {
    return isKey(key, 'g');
  };

  const isKey = (key: string, keyToCheck: string) => {
    return key === keyToCheck;
  };

  if (
    !process.env.GATSBY_SHOW_DEBUG_GRID ||
    process.env.GATSBY_SHOW_DEBUG_GRID === 'false'
  ) {
    return null;
  }

  return (
    <>
      {isVisible && (
        <>
          <div className="fixed top-0 left-0 w-screen h-screen opacity-30 pointer-events-none z-50">
            <Container>
              <Grid>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
                  (columnNumber: number) => (
                    <Col span={{ default: 1 }} key={columnNumber}>
                      <div className="h-screen bg-text/body-accent"></div>
                    </Col>
                  )
                )}
              </Grid>
            </Container>
          </div>
          <div className={`${screenSizeClasses} block sm:hidden`}>Mobile</div>
          <div className={`${screenSizeClasses} hidden sm:block md:hidden`}>
            SM (640px)
          </div>
          <div className={`${screenSizeClasses} hidden md:block lg:hidden`}>
            MD (768px)
          </div>
          <div className={`${screenSizeClasses} hidden lg:block xl:hidden`}>
            LG (1024px)
          </div>
          <div className={`${screenSizeClasses} hidden xl:block 2xl:hidden`}>
            XL (1280px)
          </div>
          <div className={`${screenSizeClasses} hidden 2xl:block 3xl:hidden`}>
            2XL (1440px)
          </div>
          <div className={`${screenSizeClasses} hidden 3xl:block`}>
            3XL (1920px)
          </div>
        </>
      )}
    </>
  );
};

export default memo(withBlokWrapper(TestingGrid, Theme.DARK));
